import React from 'react';
import { RouteMapExecutionService } from '@services/actions/RouteMapExecutionService';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { IRemoveRouteMapProps } from './IRemoveRouteMapProps';

export const RemoveRouteMapModal: React.FC<IRemoveRouteMapProps> = (props: IRemoveRouteMapProps) => {
    const serv = new RouteMapExecutionService();

    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => serv.remove(props.actionKey, props.activityKey, props.processKey, props.documentKey),
    });

    const modalContainerProps: IMessageDialogProps = {
        header: 'Удаление этапа',
        message: 'Вы действительно хотите удалить этап?',
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        onCancel: cancelClick,
        errorText: errorText,
        loading: isBusy,
        onConfirm: okClick,
    };

    return <MessageDialog {...modalContainerProps}></MessageDialog>;
};
